<ng-template #headerContent>
  @if (mode() === 'archived') {
    <div class="tw-mx-auto tw-w-full tw-self-center lg:tw-max-w-[976px] xl:tw-max-w-[1296px] tw-font-inter">
      <div class="tw-w-full">
        <div class="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center sm:tw-justify-between tw-gap-3">
          <h2 class="tw-font-inter tw-text-xl tw-font-semibold tw-text-gray-900">{{ archivedTitle() }}</h2>
          <app-events-timeline-search-input [searchControl]="searchControl" [placeholder]="searchPlaceholder()" widthClass="sm:tw-w-80"></app-events-timeline-search-input>
        </div>
      </div>
    </div>
  } @else {
    <div class="tw-mx-auto tw-flex tw-flex-col tw-gap-4 tw-w-full tw-self-center lg:tw-max-w-[976px] xl:tw-max-w-[1296px] tw-font-inter">
      <div class="lg:tw-hidden tw-flex tw-flex-col tw-gap-4">
        <div class="tw-flex tw-items-center tw-justify-between">
          <h2 class="tw-font-inter tw-text-lg tw-font-bold tw-text-gray-700">Events timeline</h2>
          @if (showCreateButton() && canCreate()) {
            <button
              type="button"
              class="tw-font-inter tw-inline-flex tw-items-center tw-gap-1 tw-text-blue-600 tw-text-sm tw-font-medium"
              (click)="onCreateEventClicked()"
            >
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.3333 5.33333H6.66667V0.666667C6.66667 0.489856 6.59643 0.320286 6.4714 0.195262C6.34638 0.0702379 6.17681 0 6 0C5.82319 0 5.65362 0.0702379 5.5286 0.195262C5.40357 0.320286 5.33333 0.489856 5.33333 0.666667V5.33333H0.666667C0.489856 5.33333 0.320286 5.40357 0.195262 5.5286C0.0702379 5.65362 0 5.82319 0 6C0 6.17681 0.0702379 6.34638 0.195262 6.4714C0.320286 6.59643 0.489856 6.66667 0.666667 6.66667H5.33333V11.3333C5.33333 11.5101 5.40357 11.6797 5.5286 11.8047C5.65362 11.9298 5.82319 12 6 12C6.17681 12 6.34638 11.9298 6.4714 11.8047C6.59643 11.6797 6.66667 11.5101 6.66667 11.3333V6.66667H11.3333C11.5101 6.66667 11.6797 6.59643 11.8047 6.4714C11.9298 6.34638 12 6.17681 12 6C12 5.82319 11.9298 5.65362 11.8047 5.5286C11.6797 5.40357 11.5101 5.33333 11.3333 5.33333Z" fill="#1C64F2" />
              </svg>
              Create event
            </button>
          }
        </div>
        <app-events-timeline-search-input [searchControl]="searchControl" [placeholder]="searchPlaceholder()" widthClass=""></app-events-timeline-search-input>
        <div class="tw-border-t tw-border-gray-200 tw-pt-4">
          <div class="tw-flex tw-flex-nowrap tw-items-center tw-gap-2 tw-overflow-x-auto tw-pb-1 [-ms-overflow-style:'none'] [scrollbar-width:'none'] [&::-webkit-scrollbar]:tw-hidden">
            @if (loadingCount()) {
              @for (_item of [1, 2, 3, 4]; track $index) {
                <div class="tw-h-10 tw-w-24 tw-shrink-0 tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>
              }
              <div class="tw-h-6 tw-shrink-0 tw-border-l tw-border-gray-300 tw-mx-1" aria-hidden="true"></div>
              <div class="tw-h-10 tw-w-40 tw-shrink-0 tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>
            } @else {
              @for (chip of filterChips(); track chip.key) {
                <button
                  type="button"
                  class="filter-chip tw-font-inter tw-inline-flex tw-shrink-0 tw-items-center tw-gap-1 tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-medium tw-transition"
                  [ngClass]="{
                    'tw-bg-blue-600 tw-text-white tw-border-blue-600 tw-border': activeFilter() === chip.key,
                    'tw-text-gray-500': activeFilter() !== chip.key,
                    'tw-opacity-50': chip.disabled
                  }"
                  [disabled]="chip.disabled"
                  (click)="onFilterSelected(chip.key)"
                >
                  <span class="tw-font-inter">{{ chip.label }}</span>
                  <span class="tw-font-inter">({{ chip.count }})</span>
                </button>
              }

              <div class="tw-h-6 tw-shrink-0 tw-border-l tw-border-gray-400 tw-mx-1" aria-hidden="true"></div>

              <button
                type="button"
                class="tw-font-inter filter-chip tw-inline-flex tw-shrink-0 tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-medium tw-text-blue-600 tw-transition"
                [class.tw-opacity-50]="archivedFilterChip().disabled"
                [disabled]="archivedFilterChip().disabled"
                (click)="onFilterSelected('archived')"
              >
                <span class="tw-inline-flex tw-items-center">
                  <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.60223 10.8H9.47581L12 5.08235H3.15524L1.02545 9.90678C0.982766 10.0035 0.964763 10.1094 0.973079 10.215C0.981395 10.3205 1.01577 10.4222 1.07307 10.511C1.13037 10.5997 1.20879 10.6726 1.3012 10.7231C1.39362 10.7736 1.49709 10.8 1.60223 10.8Z" fill="#1C64F2" />
                    <path d="M2.00168 4.56649C2.10083 4.34183 2.26258 4.15095 2.46733 4.01698C2.67208 3.88302 2.91104 3.81173 3.15524 3.81176H11.3589C11.3589 3.47478 11.2259 3.15161 10.9892 2.91332C10.7525 2.67504 10.4315 2.54118 10.0968 2.54118H7.22108L5.70656 0.508235C5.5887 0.350761 5.4362 0.222919 5.26102 0.13474C5.08584 0.0465608 4.89274 0.000441409 4.69689 0H1.2621C0.927367 0 0.606348 0.133865 0.369659 0.372147C0.13297 0.610428 0 0.933607 0 1.27059V9.10122L2.00168 4.56649Z" fill="#1C64F2" />
                  </svg>
                </span>
                <span class="tw-font-inter">Archived events ({{ archivedFilterChip().count }})</span>
              </button>
            }
          </div>
        </div>
      </div>

      <div class="tw-hidden lg:tw-flex lg:tw-items-center lg:tw-justify-between lg:tw-flex-col-reverse xl:tw-flex-row tw-gap-3">
        <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
          @if (loadingCount()) {
            @for (_item of [1, 2, 3, 4]; track $index) {
              <div class="tw-h-10 tw-w-24 tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>
            }
            <div class="tw-h-6 tw-border-l tw-border-gray-300 tw-mx-1" aria-hidden="true"></div>
            <div class="tw-h-10 tw-w-40 tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>
          } @else {
            @for (chip of filterChips(); track chip.key) {
              <button
                type="button"
                class="filter-chip tw-font-inter tw-inline-flex tw-items-center tw-gap-1 tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-medium tw-transition"
                [ngClass]="{
                  'tw-bg-blue-600 tw-text-white tw-border-blue-600 tw-border': activeFilter() === chip.key,
                  'tw-text-gray-500': activeFilter() !== chip.key,
                  'tw-opacity-50': chip.disabled
                }"
                [disabled]="chip.disabled"
                (click)="onFilterSelected(chip.key)"
              >
                <span class="tw-font-inter">{{ chip.label }}</span>
                <span class="tw-font-inter">({{ chip.count }})</span>
              </button>
            }

            <div class="tw-h-6 tw-border-l tw-border-gray-400 tw-mx-1" aria-hidden="true"></div>

            <button
              type="button"
              class="tw-font-inter filter-chip tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-medium tw-text-blue-600 tw-transition"
              [class.tw-opacity-50]="archivedFilterChip().disabled"
              [disabled]="archivedFilterChip().disabled"
              (click)="onFilterSelected('archived')"
            >
              <span class="tw-inline-flex tw-items-center">
                <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.60223 10.8H9.47581L12 5.08235H3.15524L1.02545 9.90678C0.982766 10.0035 0.964763 10.1094 0.973079 10.215C0.981395 10.3205 1.01577 10.4222 1.07307 10.511C1.13037 10.5997 1.20879 10.6726 1.3012 10.7231C1.39362 10.7736 1.49709 10.8 1.60223 10.8Z" fill="#1C64F2" />
                  <path d="M2.00168 4.56649C2.10083 4.34183 2.26258 4.15095 2.46733 4.01698C2.67208 3.88302 2.91104 3.81173 3.15524 3.81176H11.3589C11.3589 3.47478 11.2259 3.15161 10.9892 2.91332C10.7525 2.67504 10.4315 2.54118 10.0968 2.54118H7.22108L5.70656 0.508235C5.5887 0.350761 5.4362 0.222919 5.26102 0.13474C5.08584 0.0465608 4.89274 0.000441409 4.69689 0H1.2621C0.927367 0 0.606348 0.133865 0.369659 0.372147C0.13297 0.610428 0 0.933607 0 1.27059V9.10122L2.00168 4.56649Z" fill="#1C64F2" />
                </svg>
              </span>
              <span class="tw-font-inter">Archived events ({{ archivedFilterChip().count }})</span>
            </button>
          }
        </div>
        <div class="create-event-btn-container tw-flex tw-flex-col sm:tw-flex-row tw-gap-4 sm:tw-items-center lg:tw-justify-end">
          <app-events-timeline-search-input [searchControl]="searchControl" [placeholder]="searchPlaceholder()" widthClass="tw-h-full tw-block"></app-events-timeline-search-input>
          @if (showCreateButton() && canCreate()) {
            <button
              type="button"
              class="tw-font-inter tw-text-nowrap tw-h-full tw-px-4 tw-rounded-lg tw-bg-blue-600 tw-text-white tw-text-sm tw-font-medium hover:tw-bg-blue-700 tw-flex tw-items-center tw-gap-1"
              (click)="onCreateEventClicked()"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.2222 6.22222H7.77778V0.777778C7.77778 0.571498 7.69583 0.373667 7.54997 0.227806C7.40411 0.0819442 7.20628 0 7 0C6.79372 0 6.59589 0.0819442 6.45003 0.227806C6.30417 0.373667 6.22222 0.571498 6.22222 0.777778V6.22222H0.777778C0.571498 6.22222 0.373667 6.30417 0.227806 6.45003C0.0819442 6.59589 0 6.79372 0 7C0 7.20628 0.0819442 7.40411 0.227806 7.54997C0.373667 7.69583 0.571498 7.77778 0.777778 7.77778H6.22222V13.2222C6.22222 13.4285 6.30417 13.6263 6.45003 13.7722C6.59589 13.9181 6.79372 14 7 14C7.20628 14 7.40411 13.9181 7.54997 13.7722C7.69583 13.6263 7.77778 13.4285 7.77778 13.2222V7.77778H13.2222C13.4285 7.77778 13.6263 7.69583 13.7722 7.54997C13.9181 7.40411 14 7.20628 14 7C14 6.79372 13.9181 6.59589 13.7722 6.45003C13.6263 6.30417 13.4285 6.22222 13.2222 6.22222Z" fill="white" />
              </svg>
              Create event
            </button>
          }
        </div>
      </div>
    </div>
  }
</ng-template>

@if (isFloating()) {
  <div
    class="floating-header tw-fixed tw-left-0 tw-right-0 tw-z-50 tw-bg-white/95 tw-backdrop-blur-sm tw-border-b tw-border-gray-200 tw-transition-opacity tw-duration-300 tw-ease-in-out tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-pt-4 tw-pb-3 tw-opacity-0 tw-pointer-events-none"
    [class.tw-opacity-100]="showFloatingHeader()"
    [class.tw-pointer-events-auto]="showFloatingHeader()"
  >
    <ng-container [ngTemplateOutlet]="headerContent"></ng-container>
  </div>

  <div
    class="tw-pt-6 tw-transition-opacity tw-duration-300 tw-ease-in-out"
    [class.tw-opacity-0]="showFloatingHeader()"
    [class.tw-pointer-events-none]="showFloatingHeader()"
    [class.tw-opacity-100]="!showFloatingHeader()"
  >
    <ng-container [ngTemplateOutlet]="headerContent"></ng-container>
  </div>
} @else {
  <ng-container [ngTemplateOutlet]="headerContent"></ng-container>
}
